import React from 'react';
import Logo from '../assets/img/logo/792x273_text_orange.png';
import SearchBar from "../components/searchBar/SearchBarForMain";
import Footer from "../components/footer/Footer";

function MainPage() {
    return (
        <>
            <div className="mainPageContainer">
                <div className="mainPageWrap">
                    <div className="logoWrap">
                        <img src={Logo} alt="#"/>
                    </div>
                    <div className="pageTitle">
                        <span>H.I.T.S.</span>
                        <span>Digest</span>
                    </div>
                    <div className="searchBarBox">
                        <SearchBar/>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default MainPage;